<template>
  <div id="content" class="sections">
    <Head>
      <!-- Primary Meta Tags -->
      <title>{{ changeMetatagHtml($t("toolsOneForAll.metaTitle")) }}</title>

      <link rel="canonical" href="https://komatools.com/es/herramientas-one-for-all"/>
      <link rel="alternate" href="https://komatools.com/es/herramientas-one-for-all" hreflang="es"/>
      <link rel="alternate" href="https://komatools.com/en/one-for-all-tools" hreflang="en"/>
      <link rel="alternate" href="https://komatools.com/fr/outils-one-for-all" hreflang="fr"/>
      <link rel="alternate" href="https://komatools.com/es/herramientas-one-for-all" hreflang="x-default"/>

      <meta name="title" :content="changeMetatagHtml($t('toolsOneForAll.metaTitle'))">

      <meta name="description" :content="$t('toolsOneForAll.metaDescription')">

      <!-- Open Graph / Facebook -->
      <meta property="og:type" content="website">
      <meta property="og:url" content="https://komatools.com/">
      <meta property="og:title" :content="changeMetatagHtml($t('toolsOneForAll.metaTitle'))">
      <meta property="og:description" :content="$t('toolsOneForAll.metaDescription')">
      <meta property="og:image" content="https://komatools.com/img/komatoolsSocial.jpg">

      <!-- Twitter -->
      <meta property="twitter:card" content="summary_large_image">
      <meta property="twitter:url" content="https://komatools.com/">
      <meta property="twitter:title" :content="changeMetatagHtml($t('toolsOneForAll.metaTitle'))">
      <meta property="twitter:description" :content="$t('toolsOneForAll.metaDescription')">
      <meta property="twitter:image" content="https://komatools.com/img/komatoolsSocial.jpg">
    </Head>

    <div class="section light paddingBigger">
      <div>
        <div class="banner centered">
          <div class="header">
            <h1 class="title">{{ $t("toolsOneForAll.title") }}</h1>
            <h2 v-html="$t('toolsOneForAll.subTitle')" class="subTitle"></h2>
          </div>
        </div>
        <details>
          <summary v-html="$t('toolsOneForAll.summary.title')"></summary>
          <p v-html="$t('toolsOneForAll.summary.descriptionParagraph1')"></p>
          <p v-html="$t('toolsOneForAll.summary.descriptionParagraph2')"></p>
          <p v-html="$t('toolsOneForAll.summary.descriptionParagraph3')"></p>
          <p v-html="$t('toolsOneForAll.summary.descriptionParagraph4')"></p>
        </details>

        <div class="options buttons wrap centered">
          <a class="button accent" v-for="(filter, index) in filtersRef" :key="index">
            <span
                @click="filterData(filter)"
                :class="{ active: JSON.stringify(activeFilter) === JSON.stringify(filter.code) }"
            >
              {{ $t(filter.text) }}
            </span>
          </a>
        </div>

        <div class="banner centered" v-if="error">
          <p v-html="$t(error)"></p>
        </div>
        <div v-else>
          <ArticlesList :articles="articles"/>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import getArticles from '../../composables/getArticles'
import GENERIC_VARIABLES from "../../../config";
import ArticlesList from '@/components/ArticlesList.vue'
import {Head} from '@vueuse/head'
import {onMounted, ref} from 'vue'
import Tr from "@/translations"
import {useRoute} from "vue-router";


// Composition API and external JS
export default {
  name: "OneForAllTools",
  components: {ArticlesList, Head},
  setup() {
    const route = useRoute();

    const subcategories = [];
    const articles = ref([]);
    const error = ref(null);
    let loader = null;

    const filtersRef = ref([
      {text: "filtersArticles.all.text", code: ["sistema:one for all"], query: null},
      {text: "filtersArticles.tools12v.text", code: ["sistema:one for all", "voltaje:12"], query: "12v"},
      {text: "filtersArticles.tools20v.text", code: ["sistema:one for all", "voltaje:20"], query: "20v"},
    ]);

    const activeFilter = ref(filtersRef.value[0].code);

    const setupArticles = (filters) => {
      const result = getArticles(GENERIC_VARIABLES.PRODUCT_BRAND, subcategories, filters);
      loader = result.load;

      loader().then(() => {
        articles.value = result.articles.value;
        error.value = result.error.value;
      });
    };

    const filterData = (filter) => {
      activeFilter.value = filter.code;
      setupArticles(filter.code);
    };

    onMounted(() => {
      const queryFilter = route.query.filter;

      if (queryFilter) {
        const matched = filtersRef.value.find(f => f.query === queryFilter.toLowerCase());

        if (matched) {
          activeFilter.value = matched.code;
          setupArticles(matched.code);

          return;
        }
      }

      setupArticles(activeFilter.value);
    });

    const changeMetatagHtml = (html) => {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    };

    return {
      articles,
      filtersRef,
      activeFilter,
      filterData,
      error,
      GENERIC_VARIABLES,
      changeMetatagHtml,
    };
  },
};
</script>
